import { render, staticRenderFns } from "./FormCollege.vue?vue&type=template&id=9c42a6e4&scoped=true"
import script from "./FormCollege.vue?vue&type=script&lang=js"
export * from "./FormCollege.vue?vue&type=script&lang=js"
import style0 from "./FormCollege.vue?vue&type=style&index=0&id=9c42a6e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c42a6e4",
  null
  
)

export default component.exports